// app/redux/actions/demandesActions.js

// ===================== TYPES =====================

export const SET_DEMANDE_LOADING = "SET_DEMANDE_LOADING";
export const CLEAR_DEMANDE_MESSAGE = "CLEAR_DEMANDE_MESSAGE";
export const CLEAR_DEMANDE_TRACKING = "CLEAR_DEMANDE_TRACKING";

// Lists
export const GET_MY_DEMANDES_REQUEST = "GET_MY_DEMANDES_REQUEST";
export const GET_MY_DEMANDES_SUCCESS = "GET_MY_DEMANDES_SUCCESS";
export const GET_MY_DEMANDES_FAIL = "GET_MY_DEMANDES_FAIL";

export const GET_MY_FORMATION_DEMANDES_REQUEST = "GET_MY_FORMATION_DEMANDES_REQUEST";
export const GET_MY_FORMATION_DEMANDES_SUCCESS = "GET_MY_FORMATION_DEMANDES_SUCCESS";
export const GET_MY_FORMATION_DEMANDES_FAIL = "GET_MY_FORMATION_DEMANDES_FAIL";

export const GET_CREATED_BY_ME_DEMANDES_REQUEST = "GET_CREATED_BY_ME_DEMANDES_REQUEST";
export const GET_CREATED_BY_ME_DEMANDES_SUCCESS = "GET_CREATED_BY_ME_DEMANDES_SUCCESS";
export const GET_CREATED_BY_ME_DEMANDES_FAIL = "GET_CREATED_BY_ME_DEMANDES_FAIL";

export const GET_DEMANDE_TRACKING_REQUEST = "GET_DEMANDE_TRACKING_REQUEST";
export const GET_DEMANDE_TRACKING_SUCCESS = "GET_DEMANDE_TRACKING_SUCCESS";
export const GET_DEMANDE_TRACKING_FAIL = "GET_DEMANDE_TRACKING_FAIL";

// Create (3 modes)
export const CREATE_DEMANDE_COLLAB_REQUEST = "CREATE_DEMANDE_COLLAB_REQUEST";
export const CREATE_DEMANDE_COLLAB_SUCCESS = "CREATE_DEMANDE_COLLAB_SUCCESS";
export const CREATE_DEMANDE_COLLAB_FAIL = "CREATE_DEMANDE_COLLAB_FAIL";

export const CREATE_DEMANDE_MANAGER_REQUEST = "CREATE_DEMANDE_MANAGER_REQUEST";
export const CREATE_DEMANDE_MANAGER_SUCCESS = "CREATE_DEMANDE_MANAGER_SUCCESS";
export const CREATE_DEMANDE_MANAGER_FAIL = "CREATE_DEMANDE_MANAGER_FAIL";

export const CREATE_DEMANDE_RF_REQUEST = "CREATE_DEMANDE_RF_REQUEST";
export const CREATE_DEMANDE_RF_SUCCESS = "CREATE_DEMANDE_RF_SUCCESS";
export const CREATE_DEMANDE_RF_FAIL = "CREATE_DEMANDE_RF_FAIL";

export const CREATE_EVENT_DEMANDE_BY_LEARNER_REQUEST = "CREATE_EVENT_DEMANDE_BY_LEARNER_REQUEST";
export const CREATE_EVENT_DEMANDE_BY_LEARNER_SUCCESS = "CREATE_EVENT_DEMANDE_BY_LEARNER_SUCCESS";
export const CREATE_EVENT_DEMANDE_BY_LEARNER_FAIL = "CREATE_EVENT_DEMANDE_BY_LEARNER_FAIL";

export const CREATE_EVENT_DEMANDE_BY_MANAGER_REQUEST = "CREATE_EVENT_DEMANDE_BY_MANAGER_REQUEST";
export const CREATE_EVENT_DEMANDE_BY_MANAGER_SUCCESS = "CREATE_EVENT_DEMANDE_BY_MANAGER_SUCCESS";
export const CREATE_EVENT_DEMANDE_BY_MANAGER_FAIL = "CREATE_EVENT_DEMANDE_BY_MANAGER_FAIL";

export const CREATE_EVENT_DEMANDE_BY_RF_REQUEST = "CREATE_EVENT_DEMANDE_BY_RF_REQUEST";
export const CREATE_EVENT_DEMANDE_BY_RF_SUCCESS = "CREATE_EVENT_DEMANDE_BY_RF_SUCCESS";
export const CREATE_EVENT_DEMANDE_BY_RF_FAIL = "CREATE_EVENT_DEMANDE_BY_RF_FAIL";

export const CANCEL_EVENT_DEMANDE_REQUEST = "CANCEL_EVENT_DEMANDE_REQUEST";
export const CANCEL_EVENT_DEMANDE_SUCCESS = "CANCEL_EVENT_DEMANDE_SUCCESS";
export const CANCEL_EVENT_DEMANDE_FAIL = "CANCEL_EVENT_DEMANDE_FAIL";

export const WITHDRAW_EVENT_DEMANDE_REQUEST = "WITHDRAW_EVENT_DEMANDE_REQUEST";
export const WITHDRAW_EVENT_DEMANDE_SUCCESS = "WITHDRAW_EVENT_DEMANDE_SUCCESS";
export const WITHDRAW_EVENT_DEMANDE_FAIL = "WITHDRAW_EVENT_DEMANDE_FAIL";

// Bulk
export const CREATE_DEMANDE_MANAGER_BULK_REQUEST = "CREATE_DEMANDE_MANAGER_BULK_REQUEST";
export const CREATE_DEMANDE_MANAGER_BULK_SUCCESS = "CREATE_DEMANDE_MANAGER_BULK_SUCCESS";
export const CREATE_DEMANDE_MANAGER_BULK_FAIL = "CREATE_DEMANDE_MANAGER_BULK_FAIL";

export const CREATE_DEMANDE_RF_BULK_REQUEST = "CREATE_DEMANDE_RF_BULK_REQUEST";
export const CREATE_DEMANDE_RF_BULK_SUCCESS = "CREATE_DEMANDE_RF_BULK_SUCCESS";
export const CREATE_DEMANDE_RF_BULK_FAIL = "CREATE_DEMANDE_RF_BULK_FAIL";

// Manager inbox + decision
export const GET_DEMANDE_MANAGER_INBOX_REQUEST = "GET_DEMANDE_MANAGER_INBOX_REQUEST";
export const GET_DEMANDE_MANAGER_INBOX_SUCCESS = "GET_DEMANDE_MANAGER_INBOX_SUCCESS";
export const GET_DEMANDE_MANAGER_INBOX_FAIL = "GET_DEMANDE_MANAGER_INBOX_FAIL";

export const GET_DEMANDES_MANAGER_CAMPAGNE_REQUEST = "GET_DEMANDES_MANAGER_CAMPAGNE_REQUEST";
export const GET_DEMANDES_MANAGER_CAMPAGNE_SUCCESS = "GET_DEMANDES_MANAGER_CAMPAGNE_SUCCESS";
export const GET_DEMANDES_MANAGER_CAMPAGNE_FAIL = "GET_DEMANDES_MANAGER_CAMPAGNE_FAIL";

export const DEMANDE_MANAGER_DECISION_REQUEST = "DEMANDE_MANAGER_DECISION_REQUEST";
export const DEMANDE_MANAGER_DECISION_SUCCESS = "DEMANDE_MANAGER_DECISION_SUCCESS";
export const DEMANDE_MANAGER_DECISION_FAIL = "DEMANDE_MANAGER_DECISION_FAIL";

// RF inbox + decision
export const GET_DEMANDE_RF_INBOX_REQUEST = "GET_DEMANDE_RF_INBOX_REQUEST";
export const GET_DEMANDE_RF_INBOX_SUCCESS = "GET_DEMANDE_RF_INBOX_SUCCESS";
export const GET_DEMANDE_RF_INBOX_FAIL = "GET_DEMANDE_RF_INBOX_FAIL";

export const GET_DEMANDES_CAMPAGNE_REQUEST = "GET_DEMANDES_CAMPAGNE_REQUEST";
export const GET_DEMANDES_CAMPAGNE_SUCCESS = "GET_DEMANDES_CAMPAGNE_SUCCESS";
export const GET_DEMANDES_CAMPAGNE_FAIL = "GET_DEMANDES_CAMPAGNE_FAIL";

export const DEMANDE_RF_DECISION_REQUEST = "DEMANDE_RF_DECISION_REQUEST";
export const DEMANDE_RF_DECISION_SUCCESS = "DEMANDE_RF_DECISION_SUCCESS";
export const DEMANDE_RF_DECISION_FAIL = "DEMANDE_RF_DECISION_FAIL";

export const GET_COMPANY_DEMANDES_REQUEST = "GET_COMPANY_DEMANDES_REQUEST";
export const GET_COMPANY_DEMANDES_SUCCESS = "GET_COMPANY_DEMANDES_SUCCESS";
export const GET_COMPANY_DEMANDES_FAIL = "GET_COMPANY_DEMANDES_FAIL";


export const DOWNLOAD_PLAN_FORMATION_REQUEST = "DOWNLOAD_PLAN_FORMATION_REQUEST";
export const DOWNLOAD_PLAN_FORMATION_SUCCESS = "DOWNLOAD_PLAN_FORMATION_SUCCESS";
export const DOWNLOAD_PLAN_FORMATION_FAIL = "DOWNLOAD_PLAN_FORMATION_FAIL";

export const DOWNLOAD_BILAN_FORMATION_REQUEST = "DOWNLOAD_BILAN_FORMATION_REQUEST";
export const DOWNLOAD_BILAN_FORMATION_SUCCESS = "DOWNLOAD_BILAN_FORMATION_SUCCESS";
export const DOWNLOAD_BILAN_FORMATION_FAIL = "DOWNLOAD_BILAN_FORMATION_FAIL";

export const FETCH_PARTICIPATION_CAMPAGNE_REQUEST = "FETCH_PARTICIPATION_CAMPAGNE_REQUEST";
export const FETCH_PARTICIPATION_CAMPAGNE_SUCCESS = "FETCH_PARTICIPATION_CAMPAGNE_SUCCESS";
export const FETCH_PARTICIPATION_CAMPAGNE_FAIL = "FETCH_PARTICIPATION_CAMPAGNE_FAIL";

export const RELANCE_WORKFLOW_DEMANDE_REQUEST = "RELANCE_WORKFLOW_DEMANDE_REQUEST";
export const RELANCE_WORKFLOW_DEMANDE_SUCCESS = "RELANCE_WORKFLOW_DEMANDE_SUCCESS";
export const RELANCE_WORKFLOW_DEMANDE_FAIL = "RELANCE_WORKFLOW_DEMANDE_FAIL";

export const RELANCE_WORKFLOW_CAMPAGNE_REQUEST = "RELANCE_WORKFLOW_CAMPAGNE_REQUEST";
export const RELANCE_WORKFLOW_CAMPAGNE_SUCCESS = "RELANCE_WORKFLOW_CAMPAGNE_SUCCESS";
export const RELANCE_WORKFLOW_CAMPAGNE_FAIL = "RELANCE_WORKFLOW_CAMPAGNE_FAIL";

export const PROLONGER_CAMPAGNE_REQUEST = "PROLONGER_CAMPAGNE_REQUEST";
export const PROLONGER_CAMPAGNE_SUCCESS = "PROLONGER_CAMPAGNE_SUCCESS";
export const PROLONGER_CAMPAGNE_FAIL = "PROLONGER_CAMPAGNE_FAIL";

export const RELANCE_PARTICIPATION_CAMPAGNE_REQUEST = "RELANCE_PARTICIPATION_CAMPAGNE_REQUEST";
export const RELANCE_PARTICIPATION_CAMPAGNE_SUCCESS = "RELANCE_PARTICIPATION_CAMPAGNE_SUCCESS";
export const RELANCE_PARTICIPATION_CAMPAGNE_FAIL = "RELANCE_PARTICIPATION_CAMPAGNE_FAIL";



export const downloadGeneratePlanFormationExcelRequest = (cid) => ({
    type: DOWNLOAD_PLAN_FORMATION_REQUEST, cid
});
export const downloadGenerateBilanCampagneExcelRequest = (cid) => ({
    type: DOWNLOAD_BILAN_FORMATION_REQUEST,cid
});

export const fetchParticipationCampagneRequest = (campagneId) => ({
    type: FETCH_PARTICIPATION_CAMPAGNE_REQUEST,
    payload: { campagneId },
});
export const fetchParticipationCampagneSuccess = (campagneId, data) => ({
    type: FETCH_PARTICIPATION_CAMPAGNE_SUCCESS,
    payload: { campagneId, data },
});
export const fetchParticipationCampagneFail = (error) => ({
    type: FETCH_PARTICIPATION_CAMPAGNE_FAIL,
    payload: error,
});

export const relanceWorkflowDemandeRequest = (demandeId) => ({
    type: RELANCE_WORKFLOW_DEMANDE_REQUEST,
    payload: { demandeId },
});
export const relanceWorkflowDemandeSuccess = (data) => ({
    type: RELANCE_WORKFLOW_DEMANDE_SUCCESS,
    payload: data,
});
export const relanceWorkflowDemandeFail = (error) => ({
    type: RELANCE_WORKFLOW_DEMANDE_FAIL,
    payload: error,
});

export const relanceWorkflowCampagneRequest = (payload) => ({
    type: RELANCE_WORKFLOW_CAMPAGNE_REQUEST,
    payload,
});
export const relanceWorkflowCampagneSuccess = (data) => ({
    type: RELANCE_WORKFLOW_CAMPAGNE_SUCCESS,
    payload: data,
});
export const relanceWorkflowCampagneFail = (error) => ({
    type: RELANCE_WORKFLOW_CAMPAGNE_FAIL,
    payload: error,
});

export const prolongerCampagneRequest = (payload) => ({
    type: PROLONGER_CAMPAGNE_REQUEST,
    payload,
});
export const prolongerCampagneSuccess = (data) => ({
    type: PROLONGER_CAMPAGNE_SUCCESS,
    payload: data,
});
export const prolongerCampagneFail = (error) => ({
    type: PROLONGER_CAMPAGNE_FAIL,
    payload: error,
});

export const relanceParticipationCampagneRequest = (campagneIdOrPayload) => ({
    type: RELANCE_PARTICIPATION_CAMPAGNE_REQUEST,
    payload: typeof campagneIdOrPayload === "object" ? campagneIdOrPayload : { campagneId: campagneIdOrPayload },
});
export const relanceParticipationCampagneSuccess = (data) => ({
    type: RELANCE_PARTICIPATION_CAMPAGNE_SUCCESS,
    payload: data,
});
export const relanceParticipationCampagneFail = (error) => ({
    type: RELANCE_PARTICIPATION_CAMPAGNE_FAIL,
    payload: error,
});


// ===================== HELPERS =====================
export const normalizeError = (err, fallback = "Erreur") => {
    if (!err) return fallback;
    if (typeof err === "string") return err;
    if (err?.message) return String(err.message);
    if (err?.error) return String(err.error);
    try {
        return JSON.stringify(err);
    } catch {
        return fallback;
    }
};

// ===================== COMMON =====================
export const setDemandeLoading = (value) => ({
    type: SET_DEMANDE_LOADING,
    payload: !!value,
});

export const clearDemandeMessage = () => ({
    type: CLEAR_DEMANDE_MESSAGE,
});

export const clearDemandeTracking = () => ({
    type: CLEAR_DEMANDE_TRACKING,
});

// ===================== LISTS =====================
export const getMyDemandesRequest = () => ({ type: GET_MY_DEMANDES_REQUEST });
export const getMyDemandesSuccess = (data) => ({ type: GET_MY_DEMANDES_SUCCESS, payload: data });
export const getMyDemandesFail = (error) => ({ type: GET_MY_DEMANDES_FAIL, payload: error });

export const getMyFormationDemandesRequest = () => ({ type: GET_MY_FORMATION_DEMANDES_REQUEST });
export const getMyFormationDemandesSuccess = (data) => ({ type: GET_MY_FORMATION_DEMANDES_SUCCESS, payload: data });
export const getMyFormationDemandesFail = (error) => ({ type: GET_MY_FORMATION_DEMANDES_FAIL, payload: error });

export const getCreatedByMeDemandesRequest = () => ({ type: GET_CREATED_BY_ME_DEMANDES_REQUEST });
export const getCreatedByMeDemandesSuccess = (data) => ({ type: GET_CREATED_BY_ME_DEMANDES_SUCCESS, payload: data });
export const getCreatedByMeDemandesFail = (error) => ({ type: GET_CREATED_BY_ME_DEMANDES_FAIL, payload: error });

export const getDemandeTrackingRequest = (demandeId) => ({
    type: GET_DEMANDE_TRACKING_REQUEST,
    payload: { demandeId },
});
export const getDemandeTrackingSuccess = (demandeId, data) => ({
    type: GET_DEMANDE_TRACKING_SUCCESS,
    payload: { demandeId, data },
});
export const getDemandeTrackingFail = (error) => ({
    type: GET_DEMANDE_TRACKING_FAIL,
    payload: error,
});

// ===================== CREATE (3 modes) =====================
export const createDemandeCollabRequest = (payload) => ({ type: CREATE_DEMANDE_COLLAB_REQUEST, payload });
export const createDemandeCollabSuccess = (data) => ({ type: CREATE_DEMANDE_COLLAB_SUCCESS, payload: data });
export const createDemandeCollabFail = (error) => ({ type: CREATE_DEMANDE_COLLAB_FAIL, payload: error });

export const createDemandeManagerRequest = (payload) => ({ type: CREATE_DEMANDE_MANAGER_REQUEST, payload });
export const createDemandeManagerSuccess = (data) => ({ type: CREATE_DEMANDE_MANAGER_SUCCESS, payload: data });
export const createDemandeManagerFail = (error) => ({ type: CREATE_DEMANDE_MANAGER_FAIL, payload: error });

export const createDemandeRfRequest = (payload) => ({ type: CREATE_DEMANDE_RF_REQUEST, payload });
export const createDemandeRfSuccess = (data) => ({ type: CREATE_DEMANDE_RF_SUCCESS, payload: data });
export const createDemandeRfFail = (error) => ({ type: CREATE_DEMANDE_RF_FAIL, payload: error });

export const createEventDemandeByLearnerRequest = (payload) => ({ type: CREATE_EVENT_DEMANDE_BY_LEARNER_REQUEST, payload });
export const createEventDemandeByLearnerSuccess = (data) => ({ type: CREATE_EVENT_DEMANDE_BY_LEARNER_SUCCESS, payload: data });
export const createEventDemandeByLearnerFail = (error) => ({ type: CREATE_EVENT_DEMANDE_BY_LEARNER_FAIL, payload: error });

export const createEventDemandeByManagerRequest = (payload) => ({ type: CREATE_EVENT_DEMANDE_BY_MANAGER_REQUEST, payload });
export const createEventDemandeByManagerSuccess = (data) => ({ type: CREATE_EVENT_DEMANDE_BY_MANAGER_SUCCESS, payload: data });
export const createEventDemandeByManagerFail = (error) => ({ type: CREATE_EVENT_DEMANDE_BY_MANAGER_FAIL, payload: error });

export const createEventDemandeByRfRequest = (payload) => ({ type: CREATE_EVENT_DEMANDE_BY_RF_REQUEST, payload });
export const createEventDemandeByRfSuccess = (data) => ({ type: CREATE_EVENT_DEMANDE_BY_RF_SUCCESS, payload: data });
export const createEventDemandeByRfFail = (error) => ({ type: CREATE_EVENT_DEMANDE_BY_RF_FAIL, payload: error });

export const cancelEventDemandeRequest = (payload) => ({
    type: CANCEL_EVENT_DEMANDE_REQUEST,
    payload,
});
export const cancelEventDemandeSuccess = (data) => ({
    type: CANCEL_EVENT_DEMANDE_SUCCESS,
    payload: data,
});
export const cancelEventDemandeFail = (error) => ({
    type: CANCEL_EVENT_DEMANDE_FAIL,
    payload: error,
});

export const withdrawEventDemandeRequest = (payload) => ({
    type: WITHDRAW_EVENT_DEMANDE_REQUEST,
    payload,
});
export const withdrawEventDemandeSuccess = (data) => ({
    type: WITHDRAW_EVENT_DEMANDE_SUCCESS,
    payload: data,
});
export const withdrawEventDemandeFail = (error) => ({
    type: WITHDRAW_EVENT_DEMANDE_FAIL,
    payload: error,
});

// ===================== BULK =====================
export const createDemandeManagerBulkRequest = (payload) => ({ type: CREATE_DEMANDE_MANAGER_BULK_REQUEST, payload });
export const createDemandeManagerBulkSuccess = (data) => ({ type: CREATE_DEMANDE_MANAGER_BULK_SUCCESS, payload: data });
export const createDemandeManagerBulkFail = (error) => ({ type: CREATE_DEMANDE_MANAGER_BULK_FAIL, payload: error });

export const createDemandeRfBulkRequest = (payload) => ({ type: CREATE_DEMANDE_RF_BULK_REQUEST, payload });
export const createDemandeRfBulkSuccess = (data) => ({ type: CREATE_DEMANDE_RF_BULK_SUCCESS, payload: data });
export const createDemandeRfBulkFail = (error) => ({ type: CREATE_DEMANDE_RF_BULK_FAIL, payload: error });

// ===================== INBOX =====================
export const getDemandeManagerInboxRequest = () => ({ type: GET_DEMANDE_MANAGER_INBOX_REQUEST });
export const getDemandeManagerInboxSuccess = (data) => ({ type: GET_DEMANDE_MANAGER_INBOX_SUCCESS, payload: data });
export const getDemandeManagerInboxFail = (error) => ({ type: GET_DEMANDE_MANAGER_INBOX_FAIL, payload: error });

export const getDemandesManagerCampagneRequest = (payload) => ({
    type: GET_DEMANDES_MANAGER_CAMPAGNE_REQUEST,
    payload,
});
export const getDemandesManagerCampagneSuccess = (data) => ({
    type: GET_DEMANDES_MANAGER_CAMPAGNE_SUCCESS,
    payload: data,
});
export const getDemandesManagerCampagneFail = (error) => ({
    type: GET_DEMANDES_MANAGER_CAMPAGNE_FAIL,
    payload: error,
});

export const getDemandeRfInboxRequest = () => ({ type: GET_DEMANDE_RF_INBOX_REQUEST });
export const getDemandeRfInboxSuccess = (data) => ({ type: GET_DEMANDE_RF_INBOX_SUCCESS, payload: data });
export const getDemandeRfInboxFail = (error) => ({ type: GET_DEMANDE_RF_INBOX_FAIL, payload: error });

export const getDemandesCampagneRequest = (payload) => ({
    type: GET_DEMANDES_CAMPAGNE_REQUEST,
    payload,
});
export const getDemandesCampagneSuccess = (data) => ({
    type: GET_DEMANDES_CAMPAGNE_SUCCESS,
    payload: data,
});
export const getDemandesCampagneFail = (error) => ({
    type: GET_DEMANDES_CAMPAGNE_FAIL,
    payload: error,
});

// ===================== DECISIONS =====================
// payload attendu: { id, approved, comment }
export const demandeManagerDecisionRequest = (payload) => ({ type: DEMANDE_MANAGER_DECISION_REQUEST, payload });
export const demandeManagerDecisionSuccess = (data) => ({ type: DEMANDE_MANAGER_DECISION_SUCCESS, payload: data });
export const demandeManagerDecisionFail = (error) => ({ type: DEMANDE_MANAGER_DECISION_FAIL, payload: error });

export const demandeRfDecisionRequest = (payload) => ({ type: DEMANDE_RF_DECISION_REQUEST, payload });
export const demandeRfDecisionSuccess = (data) => ({ type: DEMANDE_RF_DECISION_SUCCESS, payload: data });
export const demandeRfDecisionFail = (error) => ({ type: DEMANDE_RF_DECISION_FAIL, payload: error });


export const getCompanyDemandesRequest = () => ({ type: GET_COMPANY_DEMANDES_REQUEST });
export const getCompanyDemandesSuccess = (data) => ({ type: GET_COMPANY_DEMANDES_SUCCESS, payload: data });
export const getCompanyDemandesFail = (error) => ({ type: GET_COMPANY_DEMANDES_FAIL, payload: error });
